
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/auth/directive.vue
 */
export  function checkPermissions(value) {
  if(value==undefined || value==null){
    return true
  }
  if (value && value instanceof Array && value.length > 0) {
    if(!window.customStore){
      return false;
    }
    const permissions = window.customStore.getters && window.customStore.getters.permissions
    const permissionRoles = value
    if(permissions){
        for(let i=0;i<permissions.length;i++){
          if(!permissions[i].permissions){
            return false;
          }
          for(let j=0;i<permissions[i].permissions.length;j++){
            if(permissionRoles.includes(permissions[i])[j]){
                return true;
            }
          }
        }
    }
    // const hasPermission = permissions.some(permission => {
    //   return permissionRoles.includes(permission)
    // })

    // if (!hasPermission) {
    //   return false
    // }
    return false
  } else {
    console.error(`need permissions! Like v-permission="['admin','editor']"`)
    return false
  }
  return true;
}



export  function checkPermission(value) {
  if(value==undefined || value==null){
    return true
  }
  if (value) {
    if(!window.customStore){
      return false;
    }
    const permissions = window.customStore.getters && window.customStore.getters.permissions
    const permissionRoles = value
    if(permissions){
        for(let i=0;i<permissions.length;i++){
          if(!permissions[i].permissions){
            return false;
          }
          for(let j=0;j<permissions[i].permissions.length;j++){
            if(permissions[i].permissions[j]==permissionRoles){
              return true
            }
          }
        }
    }
    // const hasPermission = permissions.some(permission => {
    //   return permissionRoles.includes(permission)
    // })

    // if (!hasPermission) {
    //   return false
    // }
    return false
  } else {
    console.error(`need permissions! Like v-permission="['admin','editor']"`)
    return false
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/util/PermissionUtil.js